export const dateShortOptions: Intl.DateTimeFormatOptions = {
    weekday: undefined,
    day: undefined,
    month: 'short',
    year: 'numeric',
}

export default dateShortOptions
